import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommissionHoldReleaseService } from 'src/app/services/commission-hold-release.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { CreditHoldReleaseStatus } from 'src/app/model/credit-hold-release-status.model';
import { ModalCommissionHoldReleaseComponent } from 'src/app/shared/modal-commission-hold-release/modal-commission-hold-release.component';
import { AuthService } from 'src/app/services/auth.service';
import { CatComponentService } from 'src/app/services/cat-component.service';

@Component({
  selector: 'app-hold-release-commission',
  templateUrl: './hold-release-commission.component.html',
  styleUrls: ['./hold-release-commission.component.css']
})
export class HoldReleaseCommissionComponent implements OnInit, OnDestroy {

  // --- Estado de la UI ---
  selected: string = 'retenciones';
  activeTab: number = 1;
  viewTable: number = 0;
  tablesVisible: boolean = false;
  idCredito: string = '';
  file: File | null = null;
  documentoAnalizado: boolean = false;
  sendResponse: boolean = false;
  montoComisionField: boolean = false;
  motivosDescuento: any[] = [];
  figurasRetencion: any[] = [];

  idAsesor: string = '';

  // --- Listas principales ---
  listValid: CreditHoldReleaseStatus[] = [];
  listInvalid: CreditHoldReleaseStatus[] = [];
  creditosConCamposInvalidos = new Set<number>();
  creditosConIdInvalido = new Set<number>();
  role: string = '';
  botonCargaRetenccionAsesor: boolean = false;

  // --- DataTables ---
  dtOptions: any = {};
  dtOptionsInvalid: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  dtTriggerInvalid: Subject<any> = new Subject<any>();

  // --- Columnas de tabla ---
  columnsValid = ['Id Crédito', 'Empleado', 'Motivo', 'Figura', 'Comentarios', '% Descuento',
    'Monto Capital', 'Fecha Cobro', 'Área Retención', 'Región', 'Estado',
    'Sucursal', 'Línea', 'Producto', 'Acciones'];

  columnsValidConComision = ['Id Crédito', 'Empleado', 'Motivo', 'Figura', 'Comentarios', '% Descuento',
    'Monto Capital', 'Monto Comisión', 'Fecha Cobro', 'Área Retención', 'Región', 'Estado',
    'Sucursal', 'Línea', 'Producto', 'Acciones'];

  columnsValidLiber = ['Id Crédito', 'Empleado', 'Monto Capital',
    'Fecha Cobro', 'Área Retención', 'Región', 'Estado',
    'Sucursal', 'Línea', 'Producto', 'Acciones'];

  columnsValidLiberConComision = ['Id Crédito', 'Empleado', 'Monto Capital', 'Monto Comisión',
    'Fecha Cobro', 'Área Retención', 'Región', 'Estado',
    'Sucursal', 'Línea', 'Producto', 'Acciones'];

  constructor(
    private toastr: ToastrService,
    private commissionHoldReleaseService: CommissionHoldReleaseService,
    public otherCatalogsService: OtherCatalogsService,
    private modalService: NgbModal,
    private catComponentService: CatComponentService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {

    this.role = this.auth.getUserRoles()[0];

    this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
      elementGrant.data.filter(el => el.component === "app-commission-hold-release-ra" && this.auth.getUserRoles().includes(el.role))
        .map(el => {
          this.botonCargaRetenccionAsesor = el.active //false para desabilitar directamente
          console.log("Botn service: ", this.botonCargaRetenccionAsesor);
        });
    });
    // ─────────────────────────────────────────────────────────────────
    // FIX 1 – Se eliminó `responsive: true` porque entra en conflicto
    //          con `table-responsive` (wrapper CSS). Usar uno u otro.
    //          Con el wrapper CSS obtenemos scroll horizontal nativo
    //          SIN perder el paginador ni las filas expandibles.
    //
    // FIX 2 – `scrollX: true` le indica a DataTables que el contenedor
    //          puede ser más ancho que la pantalla → habilita el scroll
    //          interno y renderiza el paginador correctamente.
    //
    // FIX 3 – `autoWidth: false` evita que DataTables recalcule anchos
    //          y rompa el layout después del primer render.
    // ─────────────────────────────────────────────────────────────────
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,         // FIX 2: scroll horizontal interno de DataTables
      autoWidth: false,      // FIX 3: evita recálculo de anchos que rompe layout
      language: {
        // ← Eliminar la línea url si la tienes
        // url: 'http://cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json'
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }
    };

    this.dtOptionsInvalid = { ...this.dtOptions };

    this.otherCatalogsService.getCatalogoMotivo().subscribe((catItems) => {
      this.motivosDescuento = catItems.data;
      console.log("Catalogos...", this.motivosDescuento);
    });

    this.otherCatalogsService.getFigurasRetencion().subscribe((catItems) => {
      this.figurasRetencion = catItems.data;
      console.log("Catalogos figuara retencion...", this.figurasRetencion);
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.dtTriggerInvalid.unsubscribe();
  }

  // ─────────────────────────────────────────────
  // NAVEGACIÓN DE TABS
  // ─────────────────────────────────────────────

  onNavChange(event: any): void {
    this.activeTab = event.nextId;
    let msj = '';
    if (this.activeTab === 0) {
      this.selected = 'retXasesor';
      msj = 'Retenciones por asesor';
      this.toastr.info("OPCIÓN SELECCIONADA !", msj.toUpperCase());
    } else if (this.activeTab === 1) {
      this.selected = this.activeTab === 1 ? 'retenciones' : 'liberaciones';
      msj = this.activeTab === 1 ? 'retenciones' : 'liberaciones';
      this.toastr.warning("OPCIÓN SELECCIONADA !", msj.toUpperCase());
    } else {
      this.selected = this.activeTab === 1 ? 'retenciones' : 'liberaciones';
      msj = this.activeTab === 1 ? 'retenciones' : 'liberaciones';
      this.toastr.success("OPCIÓN SELECCIONADA !", msj.toUpperCase());
    }
    this.resetLists();
  }

  // ─────────────────────────────────────────────
  // BÚSQUEDA MANUAL (1 a 1)
  // ─────────────────────────────────────────────

  getCommissionToHold(idCredito: string): void {
    if (!idCredito) return;

    const yaExiste = [...this.listValid, ...this.listInvalid]
      .some(c => c.iCreditId === +idCredito);

    if (yaExiste) {
      Swal.fire({
        icon: 'warning',
        title: 'Crédito duplicado',
        text: 'El crédito ' + idCredito + ' ya fue agregado.',
        timer: 2000,
        showConfirmButton: false
      });
      return;
    }

    this.viewTable = this.listValid.length > 0 || this.listInvalid.length > 0 ? 1 : 2;

    this.commissionHoldReleaseService.validateCreditHoldRelease([+idCredito])
      .subscribe({
        next: (response: CreditHoldReleaseStatus[]) => {
          if (response.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Crédito no encontrado',
              text: 'No se encontró información para el crédito ' + idCredito,
              timer: 2000,
              showConfirmButton: false
            });
            this.viewTable = this.listValid.length > 0 || this.listInvalid.length > 0 ? 1 : 0;
            this.idCredito = '';
            return;
          }

          const creditoValidado = response[0];

          if (this.activeTab === 1) {
            if (creditoValidado.canHold && creditoValidado.activeHoldCount > 0) {
              const areas = this.getAreaLabel(creditoValidado);
              Swal.fire({
                icon: 'warning',
                title: 'Retención en otra área',
                html: 'El crédito <strong>' + creditoValidado.iCreditId + '</strong> ya tiene una retención activa en: <strong>' + areas + '</strong>.<br><br>¿Deseas continuar de todas formas?',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Cancelar'
              }).then(result => {
                if (result.isConfirmed) {
                  this.abrirModalRetencion(creditoValidado);
                } else {
                  this.idCredito = '';
                }
              });
            } else if (creditoValidado.canHold) {
              this.abrirModalRetencion(creditoValidado);
            } else {
              this.clasificarCredito(creditoValidado);
              this.idCredito = '';
            }
          } else {
            this.clasificarCredito(creditoValidado);
            this.idCredito = '';
          }
        },
        error: () => {
          this.viewTable = this.listValid.length > 0 || this.listInvalid.length > 0 ? 1 : 0;
          this.idCredito = '';
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al consultar el crédito. Intenta de nuevo.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
  }

  // ─────────────────────────────────────────────
  // ABRIR MODAL DE RETENCIÓN
  // ─────────────────────────────────────────────

  private abrirModalRetencion(creditoValidado: CreditHoldReleaseStatus): void {
    const modalRef = this.modalService.open(ModalCommissionHoldReleaseComponent, {
      centered: true, size: 'xl', backdrop: 'static'
    });
    modalRef.componentInstance.selectedCommissionHoldRelease = creditoValidado;
    modalRef.componentInstance.catalogoMotivos = this.motivosDescuento;
    modalRef.componentInstance.figurasRetencion = this.figurasRetencion;

    modalRef.result.then(
      () => { this.idCredito = ''; },
      (objectModal) => {
        if (objectModal && typeof objectModal === 'object' && objectModal !== 'failure') {
          creditoValidado.motivoDescuento = objectModal.motivoDescuento;
          creditoValidado.figuraRetencion = objectModal.figuraRetencion;
          creditoValidado.comentarios = objectModal.comentarios;
          creditoValidado.porcentageDescontar = objectModal.porcentageDescontar;
          this.clasificarCredito(creditoValidado);
        }
        this.idCredito = '';
        this.renderTablas();
      }
    );
  }

  // ─────────────────────────────────────────────
  // CLASIFICAR UN CRÉDITO YA VALIDADO (1 a 1)
  // ─────────────────────────────────────────────

  private clasificarCredito(credit: CreditHoldReleaseStatus): void {
    const esValido = this.activeTab === 1 ? credit.canHold : credit.canRelease;

    if (esValido) {
      this.listValid = [...this.listValid, credit];
      Swal.fire({
        icon: 'success',
        title: 'Crédito agregado',
        text: 'El crédito ' + credit.iCreditId + ' fue agregado a la lista.',
        timer: 2000,
        showConfirmButton: false
      }).then(() => { this.renderTablas(); });
    } else {
      this.listInvalid = [...this.listInvalid, credit];
      this.renderTablas();
    }
  }

  // ─────────────────────────────────────────────
  // RENDER TABLAS
  // FIX 4: Se destruye la instancia DataTable antes de volver a
  //         emitir el trigger, evitando el error "Cannot reinitialise".
  // ─────────────────────────────────────────────
  private renderTablas(): void {
    // 1. Ocultar tablas para que Angular destruya los elementos del DOM
    this.tablesVisible = false;
    this.viewTable = 0;

    if (this.dtTrigger.closed) this.dtTrigger = new Subject<any>(); // ← reiniciar si está cerrado
    if (this.dtTriggerInvalid.closed) this.dtTriggerInvalid = new Subject<any>(); // ← reiniciar si está cerrado

    setTimeout(() => {
      // 2. Mostrar de nuevo → Angular recrea los <table> limpios
      this.viewTable = 1;
      this.tablesVisible = true;

      if (this.dtTrigger.closed) this.dtTrigger = new Subject<any>(); // ← reiniciar si está cerrado
      if (this.dtTriggerInvalid.closed) this.dtTriggerInvalid = new Subject<any>(); // ← reiniciar si está cerrado
      // 3. Emitir triggers con pequeño delay para asegurar que el DOM está listo
      setTimeout(() => {
        if (this.listValid.length > 0) {
          this.dtTrigger.next(null);
        }
        if (this.listInvalid.length > 0) {
          this.dtTriggerInvalid.next(null);
        }
      }, 200);
    }, 150);
  }

  // ─────────────────────────────────────────────
  // ACCIONES DE TABLA
  // ─────────────────────────────────────────────

  eliminarRegistro(item: CreditHoldReleaseStatus): void {
    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar crédito?',
      text: 'Se eliminará el crédito ' + item.iCreditId + ' de la lista.',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'
    }).then(result => {
      if (result.isConfirmed) {
        this.tablesVisible = false;

        setTimeout(() => {
          this.listValid = this.listValid.filter(c => c.iCreditId !== item.iCreditId);
          this.listInvalid = this.listInvalid.filter(c => c.iCreditId !== item.iCreditId);
          this.onCreditoEditado(item.iCreditId);
          if (this.listValid.length === 0 && this.listInvalid.length === 0) {
            this.viewTable = 0;
          } else {
            this.renderTablas();
          }
        }, 50);
      }
    });
  }

  openModalHoldRelease(item: CreditHoldReleaseStatus): void {
    const modalRef = this.modalService.open(ModalCommissionHoldReleaseComponent, {
      centered: true, size: 'xl', backdrop: 'static'
    });
    modalRef.componentInstance.selectedCommissionHoldRelease = { ...item };
    modalRef.componentInstance.catalogoMotivos = this.motivosDescuento;
    modalRef.componentInstance.figurasRetencion = this.figurasRetencion;
    modalRef.result.then(
      () => { },
      (objectModal) => {
        if (objectModal && typeof objectModal === 'object' && objectModal !== 'failure') {
          const index = this.listValid.findIndex(c => c.iCreditId === item.iCreditId);
          if (index > -1) {
            this.listValid[index].motivoDescuento = objectModal.motivoDescuento;
            this.listValid[index].figuraRetencion = objectModal.figuraRetencion;
            this.listValid[index].comentarios = objectModal.comentarios;
            this.listValid[index].porcentageDescontar = objectModal.porcentageDescontar;

            this.onCreditoEditado(objectModal.iCreditId);
          }
        }
      }
    );
  }

  // ─────────────────────────────────────────────
  // CARGA POR EXCEL
  // ─────────────────────────────────────────────

  onFileSelected(event: any): void {
    const target: DataTransfer = event.target as DataTransfer;
    if (!target.files || target.files.length === 0) return;

    this.file = target.files[0];

    if (!this.file.name.endsWith('.xlsx')) {
      Swal.fire({
        icon: 'error',
        title: 'Archivo inválido',
        text: 'Solo se permiten archivos Excel, extensión .xlsx',
        confirmButtonText: 'Entendido'
      });
      this.file = null;
      event.target.value = null;
      return;
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data: any[] = XLSX.utils.sheet_to_json(ws, { defval: null });

      const { validos, conIdInvalido } = this.mapearTipoDatos(data);

      // ── Agregar inválidos por ID directo a listInvalid ───────────
      if (conIdInvalido.length > 0) {
        const invalidos = conIdInvalido.map(c => ({
          ...c,
          canHold: false,
          canRelease: false,
          motivoRechazo: 'ID de crédito contiene caracteres no numéricos: ' + (c as any).rawIdOriginal
        } as CreditHoldReleaseStatus));

        this.listInvalid = [...this.listInvalid, ...invalidos];

        // Swal.fire({
        //   icon: 'warning',
        //   title: conIdInvalido.length + ' ID(s) inválido(s)',
        //   html: 'Los siguientes registros tienen caracteres no numéricos en el ID y fueron enviados a la tabla de inválidos:<br><br>' +
        //     '<strong>' + conIdInvalido.map(c => (c as any).rawIdOriginal).join(', ') + '</strong>',
        //   confirmButtonText: 'Entendido'
        // });
      }

      if (validos.length === 0) {
        if (conIdInvalido.length > 0) {
          // Hay inválidos pero ningún válido → renderizar solo inválidos
          this.renderTablas();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Layout vacío',
            text: 'No se encontraron créditos válidos en el layout.',
            confirmButtonText: 'Aceptar'
          });
        }
        return;
      }

      const yaExistentes = [...this.listValid, ...this.listInvalid].map(c => c.iCreditId);
      const nuevos = validos.filter(c => !yaExistentes.includes(c.iCreditId));

      if (nuevos.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'Sin registros nuevos',
          text: 'Todos los créditos del layout ya fueron agregados.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.validateAndClassify(nuevos);
    };

    reader.readAsBinaryString(this.file);
    event.target.value = null;
  }

  private mapearTipoDatos(sheetData: any[]): {
    validos: Partial<CreditHoldReleaseStatus>[],
    conIdInvalido: Partial<CreditHoldReleaseStatus>[]
  } {
    const vistos = new Set<number>();
    const validos: Partial<CreditHoldReleaseStatus>[] = [];
    const conIdInvalido: Partial<CreditHoldReleaseStatus>[] = [];

    sheetData.forEach((row: any) => {
      const cleanRow: any = {};
      Object.keys(row).forEach(key => {
        cleanRow[key.trim()] = row[key];
      });

      let percDesc = cleanRow['% A descontar'];
      if (percDesc && percDesc <= 1) { percDesc = percDesc * 100; }

      const rawId = cleanRow['IdCredito'];
      const rawIdStr = rawId !== undefined && rawId !== null
        ? String(rawId).trim() : '';
      const cleanIdStr = rawIdStr.replace(/[^0-9]/g, '');
      const creditId = cleanIdStr ? Number(cleanIdStr) : undefined;
      const idTeniaCaracteresInvalidos = rawIdStr !== cleanIdStr && rawIdStr !== '';

      const motivo = cleanRow['Motivo Descuento'] != null
        ? String(cleanRow['Motivo Descuento']).trim() : null;
      const figura = cleanRow['Figura a retener(tercia,asesor,call center)'] != null
        ? String(cleanRow['Figura a retener(tercia,asesor,call center)']).trim() : null;
      const comentarios = cleanRow['Comentarios'] != null
        ? String(cleanRow['Comentarios']).trim() : null;

      const registro: any = {
        iCreditId: creditId,
        rawIdOriginal: rawIdStr,
        motivoDescuento: motivo,
        figuraRetencion: figura,
        comentarios: comentarios,
        porcentageDescontar: String(percDesc)
      };

      // ── ID con caracteres inválidos → tabla de inválidos directo ──
      if (idTeniaCaracteresInvalidos || !creditId || isNaN(creditId) || creditId <= 0) {
        conIdInvalido.push({ ...registro, iCreditId: creditId || 0 });
        return;
      }

      // ── Duplicados → ignorar ──────────────────────────────────────
      if (vistos.has(creditId)) return;
      vistos.add(creditId);

      validos.push(registro);
    });

    return { validos, conIdInvalido };
  }

  // ─────────────────────────────────────────────
  // VALIDACIÓN Y CLASIFICACIÓN (LAYOUT / MASIVO)
  // ─────────────────────────────────────────────

  private validateAndClassify(credits: Partial<CreditHoldReleaseStatus>[]): void {
    this.tablesVisible = false;
    this.viewTable = 2;

    // ── Detectar IDs que fueron corregidos ──────────────────────────
    credits.forEach(c => {
      if ((c as any).idTeniaCaracteresInvalidos) {
        this.creditosConIdInvalido.add(c.iCreditId);
      }
    });

    //Validar motivos y figuras solo cuando sea retenciones.
    if (this.activeTab === 1) {
      const motivosValidos = this.motivosDescuento.map(m => m.motivo);
      const figurasValidas = this.figurasRetencion.map(f => f.figura);

      const creditosInvalidosCampos = credits.filter(c =>
        !motivosValidos.includes(c.motivoDescuento.toUpperCase()) ||
        !figurasValidas.includes(c.figuraRetencion.toUpperCase())
      );

      // Agregar los inválidos al Set
      creditosInvalidosCampos.forEach(c => {
        this.creditosConCamposInvalidos.add(c.iCreditId);
      });
    }

    const camposUsuario = credits.map(c => ({
      iCreditId: c.iCreditId,
      motivoDescuento: c.motivoDescuento,
      figuraRetencion: c.figuraRetencion,
      comentarios: c.comentarios,
      porcentageDescontar: c.porcentageDescontar
    }));

    const ids = credits.map(c => c.iCreditId).filter(id => id !== undefined) as number[];

    this.commissionHoldReleaseService.validateCreditHoldRelease(ids)
      .subscribe({
        next: (response: CreditHoldReleaseStatus[]) => {
          const validosNuevos: CreditHoldReleaseStatus[] = [];
          const invalidosNuevos: CreditHoldReleaseStatus[] = [];
          const conAdvertencia: CreditHoldReleaseStatus[] = [];

          response.forEach(credit => {
            const original = camposUsuario.find(c => c.iCreditId === credit.iCreditId);
            if (original) {

              if (this.activeTab === 1) {
                // ← Buscar en catálogo ignorando mayúsculas/minúsculas
                const motivoEnCatalogo = this.motivosDescuento
                  .find(m => m.motivo.toUpperCase() === original.motivoDescuento.toUpperCase());

                const figuraEnCatalogo = this.figurasRetencion
                  .find(f => f.figura.toUpperCase() === original.figuraRetencion.toUpperCase());

                // ← Asignar el valor exacto del catálogo (no el del Excel)
                credit.motivoDescuento = motivoEnCatalogo
                  ? motivoEnCatalogo.motivo       // ← valor normalizado del catálogo
                  : original.motivoDescuento;

                credit.figuraRetencion = figuraEnCatalogo
                  ? figuraEnCatalogo.figura       // ← valor normalizado del catálogo
                  : original.figuraRetencion;

                credit.porcentageDescontar = motivoEnCatalogo
                  ? motivoEnCatalogo.porcentaje   // ← porcentaje del catálogo
                  : original.porcentageDescontar; // ← fallback al del Excel

                credit.comentarios = original.comentarios;
              }
            }

            if (this.activeTab === 1) {
              if (credit.canHold) {
                validosNuevos.push(credit);
                if (credit.activeHoldCount > 0) { conAdvertencia.push(credit); }
              } else {
                invalidosNuevos.push(credit);
              }
            } else {
              if (credit.canRelease) {
                validosNuevos.push(credit);
              } else {
                invalidosNuevos.push(credit);
              }
            }
          });

          this.listValid = [...this.listValid, ...validosNuevos];
          this.listInvalid = [...this.listInvalid, ...invalidosNuevos];

          if (this.activeTab === 1 && invalidosNuevos.length > 0) {
            const ids = invalidosNuevos.map(c => c.iCreditId).join(', ');
            Swal.fire({
              icon: 'error',
              title: 'Créditos no válidos',
              html: 'Los siguientes créditos <strong>no se pueden retener</strong> porque tu área ya tiene una retención activa:<br><br><strong>' + ids + '</strong>',
              timer: 3000,
              showConfirmButton: false
            }).then(() => { this.renderTablas(); });

          } else if (this.activeTab === 2 && invalidosNuevos.length > 0) {
            const ids = invalidosNuevos.map(c => c.iCreditId).join(', ');
            Swal.fire({
              icon: 'warning',
              title: 'Créditos no liberables',
              html: 'Los siguientes créditos no se pueden liberar:<br><br><strong>' + ids + '</strong><br><br>Revisa la tabla de inválidos para más detalle.',
              timer: 3000,
              showConfirmButton: false
            }).then(() => { this.renderTablas(); });

          } else if (conAdvertencia.length > 0) {
            const ids = conAdvertencia.map(c => c.iCreditId).join(', ');
            const areas = conAdvertencia
              .map(c => this.getAreaLabel(c))
              .filter((v, i, a) => a.indexOf(v) === i)
              .join(', ');
            Swal.fire({
              icon: 'warning',
              title: 'Retención en otra área',
              html: 'Los créditos <strong>' + ids + '</strong> ya tienen una retención activa en: <strong>' + areas + '</strong>.<br><br>Fueron agregados a la lista de válidos con advertencia.',
              timer: 3000,
              showConfirmButton: false
            }).then(() => { this.renderTablas(); });

          } else {
            Swal.fire({
              icon: 'success',
              title: 'Créditos agregados',
              text: validosNuevos.length + ' crédito(s) agregados correctamente.',
              timer: 2000,
              showConfirmButton: false
            }).then(() => { this.renderTablas(); });
          }
        },
        error: (err) => {
          console.error('Error al validar créditos:', err);
          this.viewTable = 0;
          this.tablesVisible = false;
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al validar los créditos. Intenta de nuevo.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
  }

  // ─────────────────────────────────────────────
  // GUARDAR
  // ─────────────────────────────────────────────

  saveAll(): void {
    if (this.listValid.length === 0) return;

    // ← Validar pendientes de editar antes de continuar
    if (this.hayPendientesDeEditar) {
      Swal.fire({
        icon: 'warning',
        title: 'Hay pendientes de editar',
        html: `<strong>${this.creditosConCamposInvalidos.size}</strong> registro(s) tienen motivo o figura inválidos.<br><br>
                   Edita los registros marcados en rojo antes de guardar.`,
        confirmButtonText: 'Aceptar'
      });
      return; // ← detener el flujo
    }

    Swal.fire({
      icon: 'question',
      title: 'Confirmar ' + this.selected,
      text: 'Se procesarán ' + this.listValid.length + ' registro(s). ¿Deseas continuar?',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (!result.isConfirmed) return;

      this.sendResponse = true;
      this.viewTable = 2;
      this.tablesVisible = false;

      // Mapeo de CreditHoldReleaseStatus → CommissionHoldReleaseRequest
      // Los campos userRoleId/userAppId/userAppName/montoComisionTotal no existen
      // en CreditHoldReleaseStatus, por lo que se usan valores por defecto seguros.
      const payload: any[] = this.listValid.map(item => ({
        iCreditId: item.iCreditId,
        vEmployeeId: localStorage.getItem('com_employeeId') || '',
        motivoDescuento: item.motivoDescuento,
        figuraRetencion: item.figuraRetencion,
        comentarios: item.comentarios,
        porcentageDescontar: Number(item.porcentageDescontar) || 0,
        montoComisionTotal: item.MontoComisionTotal || 0,
        idTipoMovimiento: this.activeTab,
        userRoleId: localStorage.getItem('com_role') || '',
        userAppId: Number(localStorage.getItem('com_employeeId')) || 0,
        userAppName: localStorage.getItem('com_userName') || '',
      }));

      this.commissionHoldReleaseService.saveCommissionHoldRelease(payload)
        .subscribe({
          next: (res) => {
            this.resetLists();
            this.sendResponse = false;
            Swal.fire({
              icon: 'success',
              title: '¡Guardado exitoso!',
              text: 'Los registros fueron procesados correctamente.',
              confirmButtonText: 'Aceptar'
            });
          },
          error: (err) => {
            console.error('Error al guardar:', err);
            this.sendResponse = false;
            this.viewTable = 1;
            this.tablesVisible = true;
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al procesar los registros. Intenta de nuevo.',
              confirmButtonText: 'Aceptar'
            });
          }
        });
    });
  }

  // ─────────────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────────────

  getInvalidReleaseMessage(item: CreditHoldReleaseStatus): string {
    if (!item.hadPreviousHold) return 'Sin retenciones pendientes';
    return 'Retenciones liberadas';
  }

  getAreaLabel(item: CreditHoldReleaseStatus): string {
    if (!item.activeHoldRoles || item.activeHoldRoles.length === 0) return 'Disponible';
    return item.activeHoldRoles
      .map(r => this.otherCatalogsService.getAreaByRoleId(r))
      .join(', ');
  }

  resetLists(): void {
    this.tablesVisible = false;
    this.listValid = [];
    this.listInvalid = [];
    this.file = null;
    this.viewTable = 0;
    this.documentoAnalizado = false;
    this.idCredito = '';
    this.dtTrigger.unsubscribe();
    this.dtTriggerInvalid.unsubscribe();
    this.dtTrigger = new Subject<any>();
    this.dtTriggerInvalid = new Subject<any>();
  }

  validateNumber(event: KeyboardEvent): boolean {
    const charCode = event.charCode;
    return charCode >= 48 && charCode <= 57;
  }

  validatePaste(event: ClipboardEvent): boolean {
    const clipboardData = event.clipboardData ? event.clipboardData.getData('text') : '';
    return /^\d+$/.test(clipboardData);
  }

  // Verificar si un crédito tiene campos inválidos
  tieneCamposInvalidos(item: CreditHoldReleaseStatus): boolean {
    return this.creditosConCamposInvalidos.has(item.iCreditId)
      || this.creditosConIdInvalido.has(item.iCreditId);
  }

  // Al editar y guardar desde el modal, limpiar del Set
  onCreditoEditado(iCreditId: number): void {
    this.creditosConCamposInvalidos.delete(iCreditId);
    this.creditosConIdInvalido.delete(iCreditId);
  }

  // Bloquear el botón guardar si hay créditos pendientes de editar
  get hayPendientesDeEditar(): boolean {
    return this.creditosConCamposInvalidos.size > 0
      || this.creditosConIdInvalido.size > 0;
  }

}